import React from 'react';
import {
    IconTwitterWrapper,
    IconEmailWrapper,
    IconPhoneWrapper,
    IconFacebookWrapper,
    IconInstagramWrapper,
} from 'src/main/cms/FooterManagement/FooterContactUs/FooterContactUsElementsForm.style';

type ContactTypeSet = {
    icon: JSX.Element;
    label: string;
};

export const contactTypeSet = (contactType: string): ContactTypeSet | null => {
    switch (contactType) {
    case 'e-mail':
        return {
            icon: <IconEmailWrapper />,
            label: 'E-mail',
        };
    case 'phone-number':
        return {
            icon: <IconPhoneWrapper />,
            label: 'Phone number',
        };
    case 'twitter':
        return {
            icon: <IconTwitterWrapper />,
            label: 'Twitter',
        };
    case 'facebook':
        return {
            icon: <IconFacebookWrapper />,
            label: 'Facebook',
        };
    case 'instagram':
        return {
            icon: <IconInstagramWrapper />,
            label: 'Instagram',
        };
    }
    return null;
};
